import type { FC } from "react";
import React, { useEffect } from "react";
import { useState } from "react";
import FileUpload from "../components/fileupload";
import CreateFolder from "../components/createfolder";
import FileBrowser from "../components/filebrowser";
import Footer from "../components/footer";
import { useLocation } from "react-router-dom";
import { Button, Modal, PageShell, Toolbar } from "../components/ui";

import FileSats from "../components/filestats";
//files interface
const Files: FC = () => {
  const location = useLocation();
  const receivedData = location.state;
  const [pageLoaded, setPageLoaded] = useState<boolean>(false);
  const [user] = useState(JSON.parse(localStorage.getItem("user") || "{}"));
  let initialPath = "/";
  if (receivedData) {
    initialPath = receivedData;
  }

  const [folderPath, setFolderPath] = useState<string>(initialPath);
  const [counter, setCounter] = useState(0);
  const [groups, setGroups] = useState<Array<any>>([]);
  const [showUploadFiles, setShowUploadFiles] = useState(false);
  const [showCreateFolder, setShowCreateFolder] = useState(false);
  const [activeTab, setActiveTab] = useState(0);
  const updateFolder = () => {
    setCounter((counter) => counter + 1);
  };
  const updateFolderPath = (path: string) => {
    setFolderPath(path);
    setActiveTab(0);
  };
  const getgroups = async () => {
    const storedJWT = localStorage.getItem("jwt");
    await fetch(process.env.REACT_APP_API_URL + "/get-all-groups.php", {
      method: "GET",
      mode: "cors",
      headers: {
        Authorization: "Bearer " + storedJWT,
      },
    })
      .then((response) => response.json())
      .then((data) => {
        //check if data is an array
        if (!Array.isArray(data)) {
          return;
        }
        setGroups(data);
      })
      .catch((e) => {
        console.error(e);
      });
  };
  const toggleActiveTab = () => {
    setActiveTab((prevTab) => (prevTab === 0 ? 1 : 0));
  };
  const toggleCreateFileModal = () => {
    setShowUploadFiles(!showUploadFiles);
    setShowCreateFolder(false);
  };
  const toggleCreateFolderModal = () => {
    setShowCreateFolder(!showCreateFolder);
    setShowUploadFiles(false);
  };
  useEffect(() => {
    if (showUploadFiles) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "auto";
    }
  }, [showUploadFiles]);

  useEffect(() => {
    if (user.groups?.includes(0) || user.groups?.includes(1)) {
      getgroups();
    }
    setPageLoaded(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const path = location.pathname.replace("/files", "/").replace("//", "/");
    updateFolderPath(path);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const roles = JSON.parse(user.groups || "[]");

  return (
    pageLoaded && (
      <>
        <PageShell>
          {activeTab === 0 ? (
            <>
              {(roles.includes(0) || roles.includes(1)) && (
                <Toolbar>
                  {process.env.REACT_APP_FILES_CAN_UPLOAD_FILES === "true" && (
                    <Button onClick={toggleCreateFileModal}>
                      Upload files
                    </Button>
                  )}
                  {process.env.REACT_APP_FILES_CAN_CREATE_FOLDER === "true" && (
                    <Button onClick={toggleCreateFolderModal}>
                      Create folder
                    </Button>
                  )}
                </Toolbar>
              )}
              <FileBrowser
                toggleActiveTab={toggleActiveTab}
                folderPath={folderPath}
                refreshCounter={counter}
                groups={groups}
              />

              {(roles.includes(0) || roles.includes(1)) && showUploadFiles && (
                <Modal isOpen={showUploadFiles} maxWidth="md">
                  <FileUpload
                    updateFolder={updateFolder}
                    folderPath={folderPath}
                    groups={groups}
                    toggleCreateFileModal={toggleCreateFileModal}
                  />
                </Modal>
              )}
              {(roles.includes(0) || roles.includes(1)) && showCreateFolder && (
                <Modal isOpen={showCreateFolder} maxWidth="lg">
                  <CreateFolder
                    folderPath={folderPath}
                    groups={groups}
                    updateFolder={updateFolder}
                    toggleCreateFolderModal={toggleCreateFolderModal}
                  />
                </Modal>
              )}
            </>
          ) : (
            <div className="relative z-10 lg:pb-20 md:pt-10 fade-in">
              <FileSats toggleActiveTab={toggleActiveTab} />
            </div>
          )}
        </PageShell>
        <Footer />
      </>
    )
  );
};
export default Files;
